<svelte:head>
  <title>Completed needs | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<table
  class="table is-fullwidth is-hoverable"
  style="max-width:100%;table-layout:fixed;"
>
  <tbody>
    {#each items as item}
      <ItemCard {item} />
    {/each}
  </tbody>
</table>

<script lang="ts">
  import ItemCard from './_components/ItemCard.svelte';
  import { needSearchTerm } from './stores';
  import { searchAndFilterNeeds } from './utils/searchAndFilterNeeds';

  let allItems: Need_v1_Doc[] = [];

  let sortField = '';
  let sortAsc = true;

  $: items = searchAndFilterNeeds({
    sortField: sortField,
    sortAsc: sortAsc,
    items: allItems,
    searchTerm: $needSearchTerm,
  });

  let firebase = window.firebase;
  getNeeds();
  async function getNeeds() {
    firebase
      .firestore()
      .collection('needs_v1')
      .where('status', '==', 'ended')
      .onSnapshot((snap) => {
        allItems = snap.docs
          .map((doc) => ({ id: doc.id, data: doc.data() } as Need_v1_Doc))
          .sort((a, b) => (b.data.created > a.data.created ? 1 : -1));
      });
  }
</script>
